import { htmlNew, htmlTagged } from '../fun-js-lib/html'
import { hourHint } from './hint'

export function initValidateShiftTimes () {
  getShiftTimesEditableInputs().forEach(input => {
    input.addEventListener('input', validateShiftTimes)
  })
  validateShiftTimes()
}

/**
 * @param {string} str 
 */
export function isValidHour (str) {
  return /^\d{1,2}$/.test(str) && +str < 24
}

function validateShiftTimes () {
  getShiftTimesEditableInputs().forEach(input => {
    let valid = isValidOrEmpty(input.value)
    input.classList.toggle('is-invalid', !valid)
  })
  if (isShiftTimesFilledIncorrectly()) {
    setErrorHint()
  } else {
    unsetErrorHint()
  }
}

/**
 * Returns true iff some of shift times fields are filled
 * but incorrect
 */
export const isShiftTimesFilledIncorrectly = () =>
  getShiftTimesEditableInputs().some(input =>
    !isValidOrEmpty(input.value))

/**
 * @param {string} value 
 */
const isValidOrEmpty = value =>
  isValidHour(value) || value === ''

export function getShiftTimesEditableInputs () {
  return htmlTagged(container(), 'input')
    .filter(input => !input.hasAttribute('disabled'))
}

function setErrorHint () {
  unsetErrorHint()
  let hintElement = htmlNew('small')
  hintElement.classList.add('text-danger')
  hintElement.innerHTML = hourHint
  htmlTagged(container(), 'h5')[0]
    .appendChild(hintElement)
}

function unsetErrorHint () {
  htmlTagged(container(), 'h5')
    .forEach(h5 => {
      htmlTagged(h5, 'small').forEach(small => small.remove())
    })
}

function container () {
  return document.getElementById('shiftTimeContainer')
}